import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LocaleKeys from '../../locales/keys';
import OrderSummaryHeader from '../components/orderSummaryTemplate/OrderSummaryHeader';
import PlanType from '../components/orderSummaryTemplate/PlanType';
import SubscriptionQuote from '../components/orderSummaryTemplate/SubscriptionQuote';
import Total from '../components/orderSummaryTemplate/Total';
import IntroPricingDisplay from '../components/orderSummaryTemplate/IntroPricingDisplay';

const useStyles = makeStyles((theme) => ({
  itemContainer: {
    marginBottom: '10px',
  },
  orderSummaryHeaderContainer: {
    marginBottom: '20px',
  },
  reviewOrderDetailsImage: {
    [theme.breakpoints.down('lg')]: {
      marginBottom: '20px',
    },
  },
  subscriptionQuoteItemContainer: {
    marginBottom: '20px',
  },
  modifyOrderText: {
    [theme.breakpoints.up('lg')]: {
      textAlign: 'right',
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: '20px',
    },
  },
  link: {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    '&:hover': {
      color: `${theme.palette.custom.darkBlue}`,
    },
    fontFamily: 'titillium-semibold',
    WebkitFontSmoothing: 'auto',
  },
  divider: {
    border: `1px  solid ${theme.palette.custom.divider}`,
    marginBottom: '20px',
  },
  discountAmount: {
    textAlign: 'right',
  },
  totalAmount: {
    fontFamily: 'Formula1-Bold',
    fontSize: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  introPriceContainer: {
    display: 'inline-block',
  },
  introPriceLogo: {
    backgroundColor: '#15151e',
    borderColor: '#FFD300',
    borderWidth: '3px',
    borderRadius: '10px',
    borderStyle: 'solid',
    color: '#FFFFFF',
    fontSize: '13px',
    padding: '2px 5px',
    whiteSpace: 'nowrap',
    width: 'max-content',
    letterSpacing: '0.5px',
    fontWeight: 500,
    lineHeight: '15px',
    marginBottom: '5px',
  },
  introPriceCurrencySymbol: {
    fontWeight: 600,
    fontFamily: 'Formula1-Bold',
    fontSize: '13px',
    marginRight: '4px',
  },
  introPriceTotalAmount: {
    fontFamily: 'Formula1-Bold',
    fontSize: '35px',
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
    marginRight: '4px',
  },
  introPriceDiscountPrice: {
    fontSize: '28px',
    fontWeight: 600,
    marginRight: '4px',
  },
  introPriceDiscountLength: {
    fontWeight: 500,
    fontSize: '13px',
    letterSpacing: '0.5px',
    marginRight: '4px',
  },
  introPriceLine: {
    border: 'none',
    borderTop: '1px dashed #E0E0E0',
    paddingBottom: '7px',
    marginRight: '4px',
  },
  introPriceAfterDiscountPrefix: {
    fontSize: '13px',
    marginRight: '4px',
  },
  introPriceAfterDiscountPrice: {
    fontWeight: 600,
    fontSize: '13px',
  },
  introPriceAfterDiscountSuffix: {
    fontSize: '13px',
    marginLeft: '4px',
  },
  semiBold: {
    fontFamily: 'titillium-semibold',
    letterSpacing: '0.2px',
    WebkitFontSmoothing: 'auto',
  },
}));

const OrderDetailsContainer = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    translatedOrderItems,
    hasSuccessFulCOQResponse,
    hideModifyOrderLink,
  } = props;

  return (
    <Box className="ascendon-order-summary">
      <Box className="panel panel-default order-summary-container">
        <Box className="panel-body">
          {/* Cart Items */}
          <Grid className="order-item-details" container>
            {translatedOrderItems?.map((orderItem) => (
              <Grid key={orderItem.productId} item container>
                <OrderSummaryHeader
                  classes={classes}
                  thumbnailUrl={orderItem.thumbnailUrl}
                  modifyOrderLink={t(LocaleKeys.payment.orders.modifyOrder)}
                  hideModifyOrderLink={hideModifyOrderLink}
                />
                {hasSuccessFulCOQResponse && (
                  <>
                    <PlanType
                      classes={classes}
                      planTypeText={t(LocaleKeys.payment.orders.billed)}
                      planTypeValue={t(
                        LocaleKeys.payment.orders[orderItem.RenewalCycle],
                      )}
                    />
                    <Divider className={classes.divider} />
                    {/* Subscription quote  */}
                    <SubscriptionQuote
                      classes={classes}
                      renewalCycleText={t(
                        LocaleKeys.payment.orders.subscriptionQuoteRenewalCycle,
                      )}
                      renewalCycleValue={t(
                        LocaleKeys.payment.orders[orderItem.RenewalCycle],
                      )}
                    />
                    <Divider className={classes.divider} />

                    {/* Discounts */}
                    {orderItem?.introPricing?.isIntroPricing && (
                      <IntroPricingDisplay
                        totalText={t(LocaleKeys.payment.orders.total)}
                        classes={classes}
                        orderItem={orderItem}
                      />
                    )}
                  </>
                )}
                {/* Total */}
                {!orderItem?.introPricing?.isIntroPricing && (
                  <>
                    <Total
                      orderItem={orderItem}
                      classes={classes}
                      totalText={t(LocaleKeys.payment.orders.total)}
                    />
                    <Divider className={classes.divider} />
                  </>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDetailsContainer;
